import { hash } from '@ember/helper';
import { on } from '@ember/modifier';
import { action } from '@ember/object';
import { LinkTo } from '@ember/routing';
import { type Registry as Services, service } from '@ember/service';
import { PrismButton } from '@mylighthouse/prism-ember';
import HotelRatesTablesCellsTdBase from 'lumen/components/hotel/rates/tables/cells/td-base';

export default class HotelRatesTablesCellsTdHistoryChart extends HotelRatesTablesCellsTdBase {
  @service declare usageAnalytics: Services['usage-analytics'];

  @action
  trackOpenHistory(): void {
    this.usageAnalytics.track('Rate Evolution Viewed', {
      eventTrigger: 'table-view',
    });
  }

  <template>
    <LinkTo
      @query={{hash date=this.formattedDate}}
      @route="hotel.rates.detail"
      class="flex items-center gap-100 truncate"
      {{on "click" this.trackOpenHistory}}
    >
      <PrismButton
        @buttonType="secondary"
        @icon="view-chart"
        @isSmall={{true}}
      />
    </LinkTo>
  </template>
}
